/**
 * ScenarioInlineHint — Small inline alert shown near specific result sections
 * when a user action has changed the estate scenario.
 */

import React from 'react';

interface Props {
    message: string | null | undefined;
}

export const ScenarioInlineHint: React.FC<Props> = ({ message }) => {
    if (!message) return null;

    return (
        <div className="font-serif italic text-[13px] leading-relaxed text-[#1A1A1A] pl-4 border-l-2 border-[#3730A3] py-1">
            {message}
        </div>
    );
};

/**
 * Helper: returns an inline hint message for a given scenario flag, or null.
 * Use this to add contextual hints near specific UI sections.
 */
export function getInlineHint(flagId: string): string | null {
    const hints: Record<string, string> = {
        gifts: 'Adding gifts within 7 years can reduce the nil-rate band available to the estate.',
        above_2m: 'An estate above £2 million may lose some or all of the residence nil-rate band.',
        no_rnrb: 'This property setting means the residence nil-rate band may not be available.',
        rnrb_taper: 'The estate value has caused the residence nil-rate band to be tapered.',
        transferred_nrb: 'Claiming transferred NRB increases the available allowance but adds complexity.',
        spouse_exemption: 'Spouse exemption reduces the taxable estate but may affect the filing route.',
        bpr: 'Business property relief reduces the chargeable value but requires supporting evidence.',
        apr: 'Agricultural property relief reduces the chargeable value but requires supporting evidence.',
    };
    return hints[flagId] ?? null;
}
